export function InboundQuantityMismatchModal({
  mismatch,
  onCancel,
  onContinue,
}) {
  if (!mismatch) {
    return null;
  }

  const isAboveRemaining = mismatch.type === 'aboveRemaining';

  function handleKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      onCancel();
    }
  }

  return (
    <div className="kiosk-modal-backdrop" onKeyDown={handleKeyDown}>
      <section
        className="kiosk-quantity-mismatch-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="kiosk-quantity-mismatch-title"
        aria-describedby="kiosk-quantity-mismatch-description"
      >
        <h2 id="kiosk-quantity-mismatch-title">
          {isAboveRemaining
            ? 'จำนวนแพ็ครับคืนมากกว่าจำนวนคงเหลือ'
            : 'จำนวนแพ็ครับคืนไม่เพียงพอ'}
        </h2>
        <p id="kiosk-quantity-mismatch-description">
          {isAboveRemaining
            ? 'จำนวนแพ็คที่รับคืนมากกว่าจำนวนคงเหลือ คุณสามารถยกเลิกเพื่อแก้ไข หรือยืนยันเพื่อดำเนินการรับคืนต่อ'
            : 'จำนวนแพ็คที่รับคืนต้องไม่น้อยกว่าจำนวนขั้นต่ำที่แสดง กรุณายกเลิกและแก้ไขจำนวน'}
        </p>

        <dl className="kiosk-quantity-mismatch-values">
          <div>
            <dt>จำนวนที่กรอก</dt>
            <dd>{mismatch.enteredQuantityPacks} แพ็ค</dd>
          </div>
          <div>
            <dt>{isAboveRemaining ? 'จำนวนคงเหลือ' : 'จำนวนขั้นต่ำที่ต้องรับคืน'}</dt>
            <dd>
              {isAboveRemaining
                ? mismatch.remainingQuantityPacks
                : mismatch.minimumQuantityPacks}{' '}
              แพ็ค
            </dd>
          </div>
        </dl>

        <div className="kiosk-actions kiosk-quantity-mismatch-actions">
          <button
            type="button"
            className="kiosk-secondary-btn"
            onClick={onCancel}
            autoFocus
          >
            ยกเลิกและแก้ไข
          </button>
          {isAboveRemaining ? (
            <button
              type="button"
              className="kiosk-primary-btn"
              onClick={onContinue}
            >
              ยืนยันต่อ
            </button>
          ) : null}
        </div>
      </section>
    </div>
  );
}
